import { ApolloClient, ApolloLink, HttpLink, InMemoryCache, split } from '@apollo/client'
import { onError } from '@apollo/client/link/error'
import { WebSocketLink } from '@apollo/client/link/ws'
import { getMainDefinition } from '@apollo/client/utilities'
import { readStoredSession } from './lib/authToken'

const authMiddleware = new ApolloLink((operation, forward) => {
  operation.setContext(({ headers = {} }) => {
    const { token, user } = readStoredSession()

    if (token && user) {
      return {
        headers: {
          ...headers,
          Authorization: `Bearer ${token}`,
        },
      }
    }

    return { headers }
  })

  return forward(operation)
})

const httpLink = new HttpLink({
  uri: process.env.REACT_APP_GRAPHQL_SERVER,
})

const wsLink = new WebSocketLink({
  uri: process.env.REACT_APP_GRAPHQLSUBSCRIPTION,
  options: {
    reconnect: true,
    timeout: 30000,
    connectionParams: () => {
      const { token } = readStoredSession()

      return token
        ? {
            Authorization: `Bearer ${token}`,
          }
        : {}
    },
  },
})

const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query)

    return (
      definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
    )
  },
  wsLink,
  httpLink,
)

const client = new ApolloClient({
  link: ApolloLink.from([
    onError(({ graphQLErrors, networkError }) => {
      if (graphQLErrors) {
        console.error({ graphQLErrors })
      }

      if (networkError) {
        console.error({ networkError })
      }
    }),
    authMiddleware,
    splitLink,
  ]),
  cache: new InMemoryCache(),
})

export default client
